import { render, staticRenderFns } from "./versionCreate.vue?vue&type=template&id=20ddf864&"
import script from "./versionCreate.vue?vue&type=script&lang=js&"
export * from "./versionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports